module.exports = __webpack_public_path__ + "resources/group-member-unselect-ecb5914765d851c0bb3cc32537a10657.svg";